import { LoadingButton } from "@mui/lab"
import { TextField, Typography } from "@mui/material"
import { Box } from "@mui/system"
import { useEffect, useState } from "react"
import { track, useGetAccount } from "../../logic"
import { useOrganization } from "../OrganizationProvider"
import { Help } from "./Help"
import { useAuth0 } from "@auth0/auth0-react"

export const RequestInvite = () => {
  const { CompanyDisplayName, PortalDomainName } = useOrganization()
  const [email, setEmail] = useState('')
  const { loginWithRedirect } = useAuth0();

  const {
    requestInvite,
    resetRequestState,
    loading, error, data
  } = useGetAccount({ CompanyDomain: PortalDomainName })

  if (error) {
    track('error', 'useGetAccount', {}, {
      message: JSON.stringify(error),
      component: 'RequestInvite',
      company_domain: PortalDomainName,
    })
  }

  const hasCreatedAccount = data?.accountStatus === 'hasCreatedAccount'
  const inviteSent = data?.accountStatus === 'inviteSent'
  const notEligible = data?.accountStatus === 'notEligible'

  useEffect(() => {
    if (hasCreatedAccount) {
      loginWithRedirect({
        appState: { returnTo: window.location.pathname + window.location.search },
        login_hint: email,
      });
    }
  }, [hasCreatedAccount, email, loginWithRedirect]);

  return <>
    {inviteSent && (
      <Box sx={{
        display: 'flex', flexDirection: 'column', width: '100%', maxWidth: '800px', m: '0 auto', p: 2
      }}>
        <Box id="alert-dialog-title">
          <Box sx={{
            display:'flex', justifyContent: 'left', alignItems: 'center',
          }}>
            <Typography sx={{
              fontSize: 32,
              fontWeight: 300,
              lineHeight: '32px',
              letterSpacing: '-0.5px',
              mb: 6,
            }}>
            Sending sign up email</Typography>
          </Box>
        </Box>

        <Box>
          <Typography>
            Please check for an email from {CompanyDisplayName} sent to <strong>{email}</strong>. It may take up to ten minutes to arrive.
          </Typography>
          <br/>
          <Typography sx={{ mb: 3 }}>
            Haven't received your invitation? Please check your spam folder and confirm this is the email address {CompanyDisplayName} has previously used to contact you.
          </Typography>

          <Help/>

        </Box>
      </Box>
    )}


    {notEligible && (
      <Box sx={{
        display: 'flex', flexDirection: 'column', width: '100%', maxWidth: '800px', m: '0 auto', p: 2
      }}>
        <Box id="alert-dialog-title">
          <Box sx={{
            display:'flex', justifyContent: 'left', alignItems: 'center',
          }}>
            <Typography sx={{
              fontSize: 32,
              fontWeight: 300,
              lineHeight: '32px',
              letterSpacing: '-0.5px',
              mb: 6,
            }}>
              Email address not eligible
            </Typography>
          </Box>
        </Box>

        <Box>
          <Typography>
            The email address <strong>{email}</strong> is not currently eligible for an account with {CompanyDisplayName}.
          </Typography>
          <br/>
          <Typography sx={{ mb: 3 }}>
            Please confirm this is the email address {CompanyDisplayName} has previously used to contact you. If it's incorrect, please&nbsp;
            <Typography
              component="a"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                resetRequestState();
              }}
              sx={{
                color: 'primary.main',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
                cursor: 'pointer',
              }}
            >
              go back
            </Typography> to try again.
          </Typography>
          <Help/>
        </Box>
      </Box>
    )}

    {(!data || hasCreatedAccount) && (
      <>
        <Box sx={{
          display: 'flex', flexDirection: 'column', width: '100%', maxWidth: '800px', m: '0 auto',
        }}>
          <Typography sx={{
            fontSize: 36,
            fontWeight: 300,
            lineHeight: '36px',
            letterSpacing: '-0.5px',
            mb: 6, ml: 3
          }}>
            Sign in or sign up
          </Typography>
          <Box sx={{
            width: '90%', maxWidth: '500px',
            alignSelf: 'center',
          }}>
            <form onSubmit={(e) => {e.preventDefault(); requestInvite(email)}}>
              <TextField
                required
                id="outlined-required"
                label="Email"
                sx={{ width: '100%' }}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                type="email"
              />
              {/* IMPROVE: look into FormHelperText */}
              <Typography sx={{
                fontSize: 16,
                fontWeight: 400,
                lineHeight: '20px',
                letterSpacing: '0.1px',
                mt: 1, ml: 1,
              }}>
                {/* TODO: add expiration language when applicable */}
                Please enter the email address {CompanyDisplayName} has previously used to contact you.
              </Typography>

              <LoadingButton
                loading={loading || !!data}
                type="submit"
                variant="contained"
                sx={{
                  width: '100%', height: '42px', boxShadow: 'none',
                  fontSize: '16px', fontWeight: '400', mt: 6, mb: 4,
                  bgcolor: 'primary.main', color: 'white', border: 'none',
                }}
              >
                Continue
              </LoadingButton>

              <Help/>

            </form>
          </Box>
        </Box>

      </>
    )}
  </>
}
